import React from 'react';
import { View, ActivityIndicator as NativeLoadingIndicator } from 'react-native';
import { Spinner as KSpinner } from '@ui-kitten/components';
export const Native = NativeLoadingIndicator;
export const Kitten = (props) => {
    // @ts-ignore
    const { size, style, ...rest } = props;
    return (<View style={[style]}>
    <KSpinner size={size} {...rest}/>
  </View>);
};
export default {
    Native,
    Kitten,
};
//# sourceMappingURL=LoadingIndicator.js.map